import { DashboardService } from "@/services";

export default {
  name: "dashboard-scores",
  components: {},
  props: [],
  data() {
    return {
      dashboardScoresLoader: true,
      loading: false,
      campaignData: {}
    };
  },
  computed: {},
  mounted() {
    this.refreshScores();
  },
  methods: {
    copyData() {
      this.$toast.success(this.$t("dashboardPage.scoreCard.copyToast"));
    },
    refreshScores() {
      this.loading = true;
      DashboardService.getCampaigns()
        .then(response => {
          this.campaignData = response.data;
        })
        .finally(() => {
          this.dashboardScoresLoader = false;
          this.loading = false;
        });
    }
  }
};
